<template>
  <div
    class="page-header page-header-bordered page-header-tabs bg-white custom-header"
  >
    <ol class="breadcrumb" v-if="breadcrumb">
      <li
        class="breadcrumb-item"
        v-for="item in breadcrumb"
        :key="item.key"
        @click="$emit('breadcrumb-clicked', item)"
      >
        <router-link
          class="nav-link"
          :class="{ active: item.key == tabSel }"
          :to="item.url"
          v-if="!item.anchor"
          >{{ item.title }}</router-link
        >
        <a :href="item.url" @click="$emit('breadcrumb-clicked', item)" v-else>{{
          item.title
        }}</a>
      </li>
    </ol>
    <h1 class="page-title">
      {{ title }}
      <div
        class="periodSelect"
        v-if="
          ($router.currentRoute.path != '/documents') &
          !this.$isCallCenterUser &
          (this.$store.state.User.type !=
            '3436a108-96ea-11e6-ac7e-06540b81ad45')
        "
      >
        <p>
          {{ period }}
          <img
            class="ic-current-period"
            v-if="!isnotcurrentPeriod"
            src="/img/icons/ic-current-period.svg"
          />
        </p>
      </div>
    </h1>

    <slot name="header-content" />

    <ul class="nav nav-tabs nav-tabs-line" role="tablist" v-if="tabs">
      <li
        class="nav-item"
        :class="{ active: i == tabSel }"
        role="presentation"
        v-for="(tab, i) in tabs"
        v-on:click="onTabChanged(i)"
        :key="tab.key"
      >
        <router-link
          class="nav-link"
          :to="tab.url"
          role="tab"
          v-if="!tab.anchor && tab.url"
          exact
          >{{ tab.title }}</router-link
        >
        <a
          class="nav-link"
          :class="{ active: i == tabSel }"
          :href="tab.url"
          role="tab"
          v-else
          >{{ tab.title }}</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "DepHeader",
  props: ["breadcrumb", "title", "tabs", "selTabTitle"],
  data() {
    return {
      selectedTab: 0,
    };
  },
  computed: {
    tabSel() {
      var index = this.selectedTab;
      if (this.selTabTitle) {
        index = this.tabs.findIndex((t) => {
          return t.title == this.selTabTitle;
        });
        if (index == -1) index = this.selectedTab;
      }
      return index;
    },
    period() {
      if (this.$isRelative || !this.$store.state.period) {
        return "-";
      }

      if (this.$store.state.period) {
        if (this.$store.state.period.hasOwnProperty("periodName")) {
          let period = this.$store.state.period.periodName.substring(
            this.$store.state.period.periodName.indexOf("Ciclo -")
          );

          let periodArray = period.split("Ciclo -");
          return periodArray[periodArray.length - 1];
        }
      }
    },
    isnotcurrentPeriod() {
      return this.$store.getters.idPeriod && !this.$store.state.period.status;
    },
  },
  mounted() {},
  methods: {
    onTabChanged: function (_i) {
      this.selectedTab = _i;
      //Emit event for personal tab change management
      this.$emit("changed", this.tabs[_i]);
    },
    getBackground() {
      if (!this.background) return "";

      return (
        "background-image : linear-gradient(rgba(7,33,64,0.6),rgba(7,33,64,0.6)), url(" +
        this.background +
        "); background-size : cover;"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/sass/variables";

.custom-header {
  padding: 5px 30px 0px 30px;
  margin-bottom: 0px;
  height: max-content;

  .breadcrumb {
    height: 20px;

    a {
      color: #579adc;
      font-size: 14px;
      font-weight: normal;
    }

    // margin-bottom: 10px;
    // margin-left: -12px;
    .breadcrumb-item {
      .nav-link {
        display: inline-flex !important;
        padding: 0;

        &:focus {
          background: transparent;
        }

        &:hover {
          background: transparent;
        }
      }
    }
  }

  &.page-header-tabs {
    .nav-tabs-line {
      margin-top: 1px;

      li {
        a {
          padding: 2px 20px;
        }
      }
    }
  }

  .page-title {
    position: relative;
    color: #3d3d3d !important;
    margin-top: 0;
    font-weight: 500;
    font-size: 25px;
    width: 100%;
    padding-bottom: 30px;

    .periodSelect {
      float: right;
      border-radius: 6px;
      width: 145px;
      height: 30px;
      background: rgba(118, 118, 128, 0.12);
      text-align: center;

      p {
        margin: 6px;
        color: #4d4d4d;
        font-weight: normal;
        font-size: 14px;

        img {
          margin-left: 5px;
          width: 14px;
          height: 18px;
        }
      }
    }
  }
}
</style>
